import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal from "../Modal/Modal";
import { Typography } from "@mui/material";
import { isIlt } from "../../utils/course_utils";

const NoPermissionModalDialog = ({ onResult, assignment }) => {
  const { t } = useTranslation();

  return (
    <Modal
      data-qa="choose-version-modal-dialog"
      dialogContent={
        <Typography>
          {t(
            `courses.chooseVersionModal.accessDenied.${
              assignment && isIlt(assignment) ? "ilt" : "online"
            }`
          )}
        </Typography>
      }
      showCloseIcon
      open={true}
      onClose={() => onResult(null)}
      maxWidth="md"
      scrollable
    />
  );
};

NoPermissionModalDialog.propTypes = {
  assignment: PropTypes.any,
  onResult: PropTypes.func
};

export default NoPermissionModalDialog;
